define(
	'AACertified.LandingPage'
,	[
		'AACertified.LandingPage.View'
	]
,	function (
		AACertifiedLandingPageView
	)
{
	'use strict';

	return {
		mountToApp: function mountToApp (container)
		{
			var pageType = container.getComponent('PageType');

			if (pageType)
			{
				pageType.registerPageType({
					name: 'aa-certified'
				,	routes: ['aa-certified']
				,	view: AACertifiedLandingPageView
				});
			}
		}
	};
});
